export default class CreditTemplateCategoryAndActiveCountDto {
  category: string;
  count: number;
  isEditable: boolean;
}
